import React from "react";
import "./ProductDetailSkeleton.css";

/* Placeholder shown while a single product loads (see
   ProductDetailScreen.js) — shaped like the real hero image + name/
   price/description block so there's no layout jump once data arrives. */
function ProductDetailSkeleton() {
  return (
    <div className="detail-skeleton" aria-hidden="true">
      <div className="skeleton detail-skeleton-image" />
      <div className="skeleton detail-skeleton-line detail-skeleton-title" />
      <div className="skeleton detail-skeleton-line detail-skeleton-price" />
      <div className="skeleton detail-skeleton-line" />
      <div className="skeleton detail-skeleton-line detail-skeleton-line-short" />
    </div>
  );
}

export default ProductDetailSkeleton;
